var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.center'),"title":_vm.i18nt('designer.setting.center')}},[_c('el-switch',{model:{value:(_vm.optionModel.center),callback:function ($$v) {_vm.$set(_vm.optionModel, "center", $$v)},expression:"optionModel.center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }